import { render, staticRenderFns } from "./ProductPreview.vue?vue&type=template&id=04d34c7e&scoped=true"
import script from "./ProductPreview.vue?vue&type=script&lang=js"
export * from "./ProductPreview.vue?vue&type=script&lang=js"
import style0 from "./ProductPreview.vue?vue&type=style&index=0&id=04d34c7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d34c7e",
  null
  
)

export default component.exports